import { GeometryType, ResourceTypeLink, ServiceListItemDc, TableInfoDc } from "@evergis/api";
import defLines from "../../../../assets/def_lines.png";
import defMap from "../../../../assets/def_map.png";
import defNoGeom from "../../../../assets/def_noGeom.png";
import defPoints from "../../../../assets/def_points.png";
import defPoly from "../../../../assets/def_poly.png";
import defRaster from "../../../../assets/def_raster.png";
import { ResourceInfoDc } from "../../types";

export const getCardFallback = (resource: ResourceInfoDc, resourceType: ResourceTypeLink): string | null => {
  if (resourceType === ResourceTypeLink.Project) {
    return defMap;
  }

  if (
    resourceType === ResourceTypeLink.Layer &&
    ["PostgresTileLayerService", "RemoteTileService"].includes((resource as ServiceListItemDc).type)
  ) {
    return defRaster;
  }

  if (resourceType === ResourceTypeLink.Layer || resourceType === ResourceTypeLink.Table) {
    const geometryType =
      resourceType === ResourceTypeLink.Layer
        ? (resource as ServiceListItemDc).geometryType
        : (resource as TableInfoDc).geometries[0];

    switch (geometryType) {
      case GeometryType.Point:
      case GeometryType.Multipoint:
        return defPoints;
      case GeometryType.Polyline:
        return defLines;
      case GeometryType.Polygon:
        return defPoly;
      default:
        return defNoGeom;
    }
  }

  return null;
};
